import { Box, Grid, Container, Skeleton, Card, useTheme, useMediaQuery } from "../../imports/muiImport";

const FoodGiftCardSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return (
      <Container sx={{ mt: 3 }} disableGutters>
        {/* Text Content */}
        <Box
          sx={{
            mb: 2.5,
            px: 0.5,
            textAlign: "left",
          }}
        >
          {/* Title Skeleton */}
          <Skeleton
            variant="text"
            sx={{ fontSize: "20px", transform: "none", mb: 1, width: "75%" }}
          />
          {/* Subtitle Skeleton */}
          <Skeleton
            variant="text"
            sx={{ fontSize: "14px", transform: "none", mt: 1.2, width: "90%" }}
          />
        </Box>

        {/* Banner */}
        <Box
          sx={{
            width: "100%",
            height: 220,
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>

        {/* Sliding Brands Container */}
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "max-content",
            }}
          >
            {[1, 2, 3, 4].map((i) => (
              <Card
                key={i}
                sx={{
                  width: 100, // Provides visual fallback structural spacing matching original intent
                  height: 70,
                  background: "rgba(255,255,255,0.9)",
                  borderRadius: 2,
                  boxShadow: "none",
                  p: 1,
                }}
              >
                <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: "10px" }} />
              </Card>
            ))}
          </Box>
        </Box>
      </Container>
    );
  }

  // above (sm)>600PX design skeleton
  return (
    <Container maxWidth="xl" disableGutters>
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        sx={{
          minHeight: {
            xs: 200,
            sm: 250,
            md: 320,
            lg: 400,
          },
          mb: 5,
          mt: 5,
        }}
      >
        {/* banner image skeleton */}
        <Grid item xs={5} display="flex">
          <Box sx={{ width: "100%", height: "100%" }}>
            <Skeleton
              variant="rectangular"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: 2,
              }}
            />
          </Box>
        </Grid>

        {/* content skeleton */}
        <Grid item xs={7} display="flex">
          <Box
            sx={{
              width: "100%",
              height: "100%",
              background: "#fcfcfc",
              borderRadius: 5,
              p: { xs: 1.5, sm: 2, md: 3 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {/* Title Skeleton reflecting fluid font-sizes */}
            <Box sx={{ mt: 1 }}>
              <Skeleton
                variant="text"
                sx={{
                  fontSize: { xs: "14px", sm: "18px", md: "24px", lg: "30px" },
                  transform: "none",
                  width: "80%"
                }}
              />
            </Box>

            {/* Subtitle Skeleton */}
            <Box sx={{ mt: 1, mb: 2 }}>
              <Skeleton
                variant="text"
                sx={{
                  fontSize: { xs: "10px", sm: "12px", md: "14px" },
                  transform: "none",
                  width: "95%"
                }}
              />
            </Box>

            {/* Cards Grid */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 1.5,
                mt: 2,
              }}
            >
              {[1, 2, 3].map((i) => (
                <Card
                  key={i}
                  sx={{
                    width: 212,
                    height: 120,
                    background: "transparent",
                    boxShadow: "none",
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FoodGiftCardSkeleton;